import Consts from '../consts/adminConsts'

export default class{
    AllRights = Consts.UserRights;

    Type = Consts.UserType;
       

    Admin = this.AllRights[0];
    
    Auditor = this.AllRights[1];       
    
    Inspector = this.AllRights[2];      
    
    Service = this.AllRights[3];   
    
    NotDaxUser = this.AllRights[4];     
    

    Private = this.Type[0];
    
    Public = this.Type[1];
    
    rights = function(value) {
        if(!value) return this.AllRights;

        return value.Id == 1 
                    ? this.AllRights.filter(e => e.Id != 5)
                    : this.AllRights;
    };

    isPrivate = function(value) {
        if(!value) return;
        return value.Id == 5 ? false : true;
    }

} 